import { CSSProperties, FC, ReactNode } from "react";
import classes from "./Metrics.module.less";

export interface Metric {
    label: string;
    value: ReactNode;
}

interface MetricsProps {
    metrics: Metric[];
    style?: CSSProperties;
}

/** The vendor page's banner of headline numbers, styled like the dashboard's. */
export const Metrics: FC<MetricsProps> = ({ metrics, style }) => (
    <div className={classes.container} style={style}>
        {metrics.map((item) => (
            <div className={classes.metric} key={item.label}>
                <div className={classes.label}>{item.label}</div>
                <div className={classes.value}>{item.value}</div>
            </div>
        ))}
    </div>
);
